import React, {useEffect, useState} from "react";
import API from 'libs/api';
import ICON from 'components/cmp_icon/cmp_icon'
import TABLE from 'components/cmp_table/cmp_table'

import MDL_DOMAIN from "./mdl_domain/mdl_domain";

import './crd_domains.css';


//  table config ================================================================================================

const statusConfigs = {
    'DOMAINS': {
        title: 'Domains',
        description: 'All domains',
        columns: [
            { key: 'host', sortby: 'host', label: 'Domain' },
            { key: 'search_city', label: 'Search city' },
            { key: 'provider', sortby: 'provider', width: '48px', label: 'Rev' },
            { key: 'step', sortby: 'step', label: 'Step' },
            { key: 'status', sortby: 'status', label: 'Status' },
            { key: 'lastmodified_formatted', sortby: 'lastmodified', width: '192px', label: 'Modified' },
            { key: 'lastmodifiedby', label: 'Last modified by' },
        ],
        statusFilterButtons: [
            { label: 'Provider', value: 'YES', param: 'provider' },
            { label: 'Not provider', value: 'NO', param: 'provider' }
        ]
    },
    'CLASSIFICATION': {
        title: 'Classifications',
        description: 'Domains determined by initial AI scans to belong to a service provider',
        columns: [
            { key: 'host', sortby: 'host', label: 'Domain' },
            { key: 'search_city', label: 'Search city' },
            { key: 'step', label: 'Step' },
            { key: 'status', label: 'Status' },
            { key: 'lastmodified_formatted', sortby: 'lastmodified', width: '192px', label: 'Modified' },
            { key: 'lastmodifiedby', label: 'Last modified by' },
        ],
        statusFilterButtons: [
            { label: 'Pending', value: 'PENDING', param: 'status' },
            { label: 'Failed', value: 'FAILED', param: 'status' }
        ]
    },
    'SCRAPE': {
        title: 'Scraping',
        description: 'Domains determined by initial AI scans to belong to a service provider but have more than 100 pages and were not processed',
        columns: [
            { key: 'host', sortby: 'host', label: 'Domain' },
            { key: 'search_city', label: 'Search city' },
            { key: 'step', label: 'Step' },
            { key: 'status', label: 'Status' },
            { key: 'lastmodified_formatted', sortby: 'lastmodified', width: '192px', label: 'Modified' },
            { key: 'lastmodifiedby', label: 'Last modified by' },
        ],
        statusFilterButtons: [
            { label: 'Pending', value: 'PENDING', param: 'status' },
            { label: 'Blocked', value: 'BLOCKED', param: 'status' },
            { label: 'Failed', value: 'FAILED', param: 'status' }
        ]
    },
    'EXTRACTION': {
        title: 'Extractions',
        description: 'Domains determined by initial AI scans to belong to a service provider but no locations could be found in the selected country',
        columns: [
            { key: 'host', sortby: 'host', label: 'Domain' },
            { key: 'search_city', label: 'Search city' },
            { key: 'step', label: 'Step' },
            { key: 'status', label: 'Status' },
            { key: 'location_count', width: '100px', label: 'Locations' },
            { key: 'activity_count', width: '100px', label: 'Activities' },
            { key: 'lastmodified_formatted', sortby: 'lastmodified', width: '192px', label: 'Modified' },
            { key: 'lastmodifiedby', label: 'Last modified by' },
        ],
        statusFilterButtons: [
            { label: 'Review', value: 'REVIEW', param: 'status' },
            { label: 'Pending', value: 'PENDING', param: 'status' },
            { label: 'Failed', value: 'FAILED', param: 'status' }
        ]
    },
    'PUBLISH': {
        title: 'Published',
        description: 'Domains determined by initial AI scans to belong to a service provider but was unable to process any pages',
        columns: [
            { key: 'host', sortby: 'host', label: 'Domain' },
            { key: 'search_city', label: 'Search city' },
            { key: 'step', label: 'Step' },
            { key: 'status', label: 'Status' },
            { key: 'lastmodified_formatted', sortby: 'lastmodified', width: '192px', label: 'Modified' },
            { key: 'lastmodifiedby', label: 'Last modified by' },
        ],
        statusFilterButtons: [
            { label: 'Pending', value: 'PENDING', param: 'status' },
            { label: 'Published', value: 'PUBLISHED', param: 'status' }
        ]
    }
};


export default function CRD_DOMAINS({status}) {

    //  variable declarations ------------------------------------------------------------------------------------------

    //  data table variables
    const [var_data, set_data] = useState([]);
    const [var_data_settings, set_data_settings] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'lastmodified',
        sortorder: 'desc'
    });
    const [var_totalrows, set_totalrows] = useState(0);

    //  data ready variables
    const [var_ready, set_ready] = useState(false);
    const [var_processing, set_processing] = useState('inactive');

    //  other variables
    const [var_cardtitle, set_cardtitle] = useState('');
    const [var_carddescription, set_carddescription] = useState('');

    //  modal variables
    const [var_domain_open, set_domain_open] = useState(false);
    const [var_domainID, set_domainID] = useState('');
    const [var_domainHost, set_domainHost] = useState('');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {

        const config = statusConfigs[status];
        if (config) {
            set_cardtitle(config.title);
            set_carddescription(config.description);
        }

        set_totalrows('');
        let var_reset_settings = {
            limit: 15,
            offset: 0,
            totalrows: 0,
            search: '',
            sortby: 'lastmodified',
            sortorder: 'desc'
        };

        populate_domains(var_reset_settings);

    }, [status])



    //  async functions ------------------------------------------------------------------------------------------------

    async function populate_domains(data_settings) {

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_domains(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            const dataToSet = results.results === undefined ? [] : results.results;
            set_data(dataToSet);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_domains(settings) {
        const queryParams = {
            search: settings.search,
            sortby: settings.sortby,
            sortorder: settings.sortorder,
            limit: settings.limit,
            offset: settings.offset
        };

        if (status !== 'DOMAINS') {
            queryParams.step = status;
        }

        if (settings.status) {
            queryParams.status = settings.status;
        }

        if (settings.provider) {
            queryParams.provider = settings.provider;
        }

        let var_parameters = {queryStringParameters: queryParams};
        return API.get('admin-domains', '/get-domains', var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_domain(domain) {
        set_domainID(domain.id);
        set_domainHost(domain.host)
        set_domain_open(true);
    }



    // RENDER CONTAINER ================================================================================================

    const config = statusConfigs[status];

    return (

      <div className='card domains'>
          <div className='card__header'>
              <div className='card__header__title_totalrows'>
                  <div className='text--md bold'>{var_cardtitle}</div>
                  <div className='card__header__totalrows text--md normal'>{typeof var_totalrows === 'number' ? var_totalrows.toLocaleString() : ''}</div>
              </div>
              <div className='card__header__description text--base'>{var_carddescription}</div>
          </div>
          <div className='card__content'>

              <TABLE
                var_data_settings={var_data_settings}
                set_data_settings={set_data_settings}
                onChange={populate_domains}
                processing={var_processing}
                totalrows={var_totalrows}
                columns={config?.columns || []}
                items={var_data}
                onRowClick={onClick_domain}
                filterButtons={config?.statusFilterButtons}
                defaultSelectedFilter="all"
                // renderCell={(item, column) => {
                //     if (column.key === 'provider') {
                //         return item.provider === 'YES' && (
                //           <div className='icon--reviewed'>
                //               <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                //           </div>
                //         );
                //     }
                //     return item[column.key];
                // }}
              />

          </div>

          <MDL_DOMAIN
            onOpen={var_domain_open}
            onClose={() => set_domain_open(false)}
            onRefresh={populate_domains}
            var_domainHost={var_domainHost}
            domainId={var_domainID}
          />

      </div>

    )
}